if (!customElements.get('collapsible-component')) {
  class CollapsibleComponent extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('summary').forEach(summary => {
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      });
    }
    onSummaryClick(event) {
      const details = event.currentTarget.closest('details');
      if (!details) return;
      event.preventDefault();
      const willOpen = !details.hasAttribute('open');
      if (willOpen) { details.setAttribute('open', ''); } else { details.removeAttribute('open'); }
      event.currentTarget.setAttribute('aria-expanded', String(willOpen));
    }
  }
  customElements.define('collapsible-component', CollapsibleComponent);
}

(function () {
  function initAccordions() {
    document.querySelectorAll('.accordion details').forEach(function (details) {
      var summary = details.querySelector('summary');
      if (!summary || summary._fcInit) return;
      summary._fcInit = true;
      summary.addEventListener('click', function (event) {
        if (summary.closest('collapsible-component')) return;
        event.preventDefault();
        var willOpen = !details.hasAttribute('open');
        if (willOpen) { details.setAttribute('open', ''); } else { details.removeAttribute('open'); }
        summary.setAttribute('aria-expanded', String(willOpen));
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
    initAccordions();
  }
  new MutationObserver(function (m) {
    if (m.some(function (x) { return x.addedNodes.length > 0; })) initAccordions();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();